import { useCallback, ReactNode } from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { cn } from '@/lib/utils';

interface AccordionStepperProps {
    value?: string;
    onValueChange?: (value: string | undefined) => void;
    defaultValue?: string;
    children: ReactNode;
    className?: string;
}

export function AccordionStepper({
    value,
    onValueChange,
    defaultValue,
    children,
    className,
}: AccordionStepperProps) {
    const handleValueChange = useCallback(
        (newValue: string | undefined) => {
            onValueChange?.(newValue);
        },
        [onValueChange],
    );

    return (
        <AccordionPrimitive.Root
            type="single"
            value={value}
            onValueChange={handleValueChange}
            defaultValue={defaultValue}
            className={cn(
                'accordion-stepper flex flex-col gap-4 relative',
                className,
            )}
        >
            {children}
        </AccordionPrimitive.Root>
    );
}
